import { Texture } from "three";
var GRADIENTS = [
    // だんご上
    // 下だけ暗く
    [
        [0.75, '#fff'],
        [1, '#000']
    ],
    // だんご中
    // 上下暗く
    [
        [0.0, '#000'],
        [0.25, '#fff'],
        [0.75, '#fff'],
        [1, '#000']
    ],
    // だんご下
    // 上暗く
    [
        [0.0, '#000'],
        [0.25, '#fff'],
    ]
];
var DumplingAOTexture = /** @class */ (function () {
    // ----------------------------------------------------------------------------------------------------
    // Construct
    //
    function DumplingAOTexture() {
        this.contexts = [];
        this.textures = [];
        var _loop_1 = function (i) {
            var canvas = document.createElement('canvas');
            canvas.width = 256;
            canvas.height = 256;
            var context = canvas.getContext("2d");
            var gradient = context.createLinearGradient(0, 0, 0, 256);
            GRADIENTS[i].forEach(function (colorStep) {
                gradient.addColorStop.apply(gradient, colorStep);
            });
            context.fillStyle = gradient;
            context.fillRect(0, 0, 256, 256);
            var texture = new Texture(canvas);
            texture.needsUpdate = true;
            this_1.contexts[i] = context;
            this_1.textures[i] = texture;
        };
        var this_1 = this;
        for (var i = 0; i < 3; i++) {
            _loop_1(i);
        }
    }
    return DumplingAOTexture;
}());
export { DumplingAOTexture };
